<template>
    <el-container style="border: 1px solid #eee">
        <el-header style="border-bottom: 1px solid #eee;height: 50px !important;">
            <div class="flex flex-v-center flex-between">
                <el-page-header @back="goBack">
                    <h4 slot="content">{{ $t('教师中心') }}</h4>
                </el-page-header>
                <div class="flex flex-v-center">
                    <img :src="$host + teacher.avatar"
                        style="width: 40px;height: 40px;border-radius: 50%;margin-right: 10px;" />
                    <span>{{ teacher.name }}</span>
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside width="180px" style="border-right: 1px solid #eee;margin-top: 10px;">
                <el-menu router :default-active="$route.path" class="el-menu-vertical-demo">
                    <el-menu-item index="/main/teacher/class">
                        <template slot="title"><i class="el-icon-postcard"></i>班级</template>
                    </el-menu-item>

                    <el-menu-item index="/main/teacher/review" class="item">
                        <template slot="title"><i class="el-icon-document-checked"></i>批改作业</template>
                        <el-badge style="position: absolute; top: -10px; right: 40px;" v-if="$store.state.workCount > 0"
                            :value="$store.state.workCount"></el-badge>
                    </el-menu-item>

                    <el-menu-item index="/main/teacher/homework">
                        <template slot="title"><i class="el-icon-document"></i>已布置作业</template>
                    </el-menu-item>

                    <el-menu-item index="/main/teacher/student">
                        <template slot="title"><i class="el-icon-user"></i>学生</template>
                    </el-menu-item>
                </el-menu>
            </el-aside>

            <el-main style="height: 600px;overflow: scroll;">
                <keep-alive :include="include">
                    <router-view></router-view>
                </keep-alive>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            include: [],
        }
    },
    computed: {
        teacher: function () {
            return this.$store.state.user.teacher;
        }
    },

    methods: {
        goBack() {
            this.$router.push('/main');
        }
    },
};
</script>